<template>
  <b-overlay
    :show="mapLoad"
    variant="primary"
    :opacity="0.2"
    rounded="sm"
    style="min-height: 200px"
  >
    <div class="media-container">
      <div class="google-map" id="googleMapScroll" ref="googleMap" style="position: absolute;"></div>
      <b-button variant="link" class="reset-filter" @click="defaultMap" v-if="isRefresh">
        <b-icon icon="arrow-counterclockwise"></b-icon>
      </b-button>
    </div>
  </b-overlay>
</template>

<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import MapMixin from '@/mixins/MapMixin';
import { Loader } from '@googlemaps/js-api-loader';
import { MapModule } from '@/store/modules/map';
import { AppModule } from '@/store/modules/app';
// eslint-disable-next-line import/named
import { GOOGLE_MAP_KEY } from '@/config/constant';

@Component
export default class GoogleMap extends mixins(MapMixin) {
  @Prop({ default: true }) isRefresh!: boolean;

  async loadMap() {
    const loader = new Loader({
      apiKey: GOOGLE_MAP_KEY,
    });
    loader
      .load()
      .then((google) => {
        this.google = google;
        this.loadMapOptions()
          .then(() => {
            this.initializeMapFilter();
          });
      });
  }

  defaultMap() {
    MapModule.SetParamDefault();
    AppModule.SetVisibleMap(false);
    this.$nextTick(() => {
      AppModule.SetVisibleMap(true);
    });
  }

  created() {
    this.loadMap();
  }
}
</script>
<style scoped lang="scss">
.media-container {
  position: relative;
  padding-bottom: 56%;
  padding-top: 30px;
  height: 0;
  overflow: hidden;
  border-radius: 5px;
  .google-map {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: none;
  }
}
.reset-filter {
  position: absolute;
  right: 10px;
  top: 11px;
  background: white;
  height: 42px;
  width: 42px;
  cursor: pointer;
  z-index: 1;
  border-radius: 3px;
  -moz-box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);
  border: 1px solid #d3d3d3;
  -webkit-transition: width 0.3s;
  -moz-transition: width 0.3s;
  -o-transition: width 0.3s;
  transition: width 0.3s;
  padding: 5px;
  img {
    min-width: 100%;
    width: 100%;
  }
}
</style>
